(() => {
  const JP_PREFECTURE_NAMES = {
    "JP-01": "北海道",
    "JP-02": "青森",
    "JP-03": "岩手",
    "JP-04": "宮城",
    "JP-05": "秋田",
    "JP-06": "山形",
    "JP-07": "福島",
    "JP-08": "茨城",
    "JP-09": "栃木",
    "JP-10": "群馬",
    "JP-11": "埼玉",
    "JP-12": "千葉",
    "JP-13": "東京",
    "JP-14": "神奈川",
    "JP-15": "新潟",
    "JP-16": "富山",
    "JP-17": "石川",
    "JP-18": "福井",
    "JP-19": "山梨",
    "JP-20": "長野",
    "JP-21": "岐阜",
    "JP-22": "静岡",
    "JP-23": "愛知",
    "JP-24": "三重",
    "JP-25": "滋賀",
    "JP-26": "京都",
    "JP-27": "大阪",
    "JP-28": "兵庫",
    "JP-29": "奈良",
    "JP-30": "和歌山",
    "JP-31": "鳥取",
    "JP-32": "島根",
    "JP-33": "岡山",
    "JP-34": "広島",
    "JP-35": "山口",
    "JP-36": "徳島",
    "JP-37": "香川",
    "JP-38": "愛媛",
    "JP-39": "高知",
    "JP-40": "福岡",
    "JP-41": "佐賀",
    "JP-42": "長崎",
    "JP-43": "熊本",
    "JP-44": "大分",
    "JP-45": "宮崎",
    "JP-46": "鹿児島",
    "JP-47": "沖縄",
  };

  const isJapanAddress = (address = {}) => {
    return address?.country === "Japan" || address?.countryCode === "JP" || address?.provinceCode?.startsWith("JP-");
  };

  const toHalfWidthDigits = (value = "") => {
    return value.replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0));
  };

  const normalizeFloorLabel = (value = "") => {
    return toHalfWidthDigits(value).replace(/(\d+)\s*階/g, "$1F");
  };

  const normalizePhoneNumber = (value = "") => {
    const jpValue = toHalfWidthDigits(value).replace(/＋/g, "+").trim();
    if (!jpValue.startsWith("+81")) {
      return value;
    }

    const normalized = jpValue.replace(/\(0\)/g, "0").replace(/[\s\-‐－ー―−]/g, "");

    const localNumber = normalized.slice(3).replace(/^0+/, "");
    return localNumber ? `0${localNumber}` : normalized;
  };

  const formatAddress = (address = {}) => {
    if (isJapanAddress(address)) {
      const province = JP_PREFECTURE_NAMES[address?.provinceCode] || address?.province;
      const address1 = normalizeFloorLabel(address?.address1 || "");
      const address2 = normalizeFloorLabel(address?.address2 || "");

      return [
        [address?.zip ? `〒${address.zip}` : null, [province, address?.city, address1, address2].filter(Boolean).join(", ")]
          .filter(Boolean)
          .join(" "),
      ];
    }

    return [address?.zip, address?.country, address?.province, address?.city, address?.address1, address?.address2].filter(Boolean);
  };

  const normalizeAddressLine = (value = "", address = {}) => {
    if (!isJapanAddress(address)) {
      return value;
    }

    return normalizeFloorLabel(value);
  };

  window.SDG = window.SDG || {};
  window.SDG.storeLocatorAddressFormatter = {
    format: formatAddress,
    normalizeLine: normalizeAddressLine,
    normalizePhoneNumber: normalizePhoneNumber,
  };
})();
